import { all_routes } from "../../../feature-module/router/all_routes";
const routes = all_routes as any;

export const SidebarData: any = {
  ADMIN: [
    {
      // tittle: "Left Menu",
      icon: "airplay",
      showAsTab: true,
      separateRoute: false,
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.adminDashboard,
          submenu: false,
          showSubRoute: false,
          icon: "smart-home",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "Office Location",
          link: routes.officeLocation.list,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-building",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
          permissionCode: routes.officeLocation.list.slice(1),
        },
        // {
        //   label: "Master Beacon",
        //   link: routes.masterBeacon.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-broadcast",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        //   permissionCode: routes.masterBeacon.list.slice(1),
        // },
        {
          label: "Work Shift",
          link: routes.workShift,
          submenu: false,
          showSubRoute: false,
          icon: "user-star",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
          permissionCode: routes.workShift.slice(1),
        },
        {
          label: "Employees",
          link: routes.employees.list,
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-building",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [
            {
              label: "Employee List",
              link: routes.employees.list,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            // {
            //   label: "Employee Leaves",
            //   link: "",
            //   icon: "ti ti-settings",
            //   submenu: false,
            //   showSubRoute: false,
            // },
            // {
            //   label: "Profile Reasons",
            //   link: routes.employees.profile_reasons,
            //   icon: "ti ti-settings",
            //   submenu: false,
            //   showSubRoute: false,
            // },
          ],
        },

        {
          label: "Services",
          link: routes.services.list,
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-building",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [
            {
              label: "VPF",
              link: routes.vpf.list,
              icon: "ti ti-briefcase",
              submenu: false,
              showSubRoute: false,
              dot: false,
              submenuItems: [],
            },
            {
              label: "Reimbursement",
              link: routes.reimbursementAdmin,
              icon: "ti ti-receipt",
              submenu: false,
              showSubRoute: false,
              dot: false,
              submenuItems: [],
            },
            {
              label: "IT Declaration",
              link: routes.itDeclaration.list,
              icon: "ti ti-file-check",
              submenu: false,
              showSubRoute: false,
              dot: false,
              submenuItems: [],
            },
            {
              label: "Reimbursement Sync",
              link: routes.reimbursementSync,
              icon: "ti ti-refresh",
              submenu: false,
              showSubRoute: false,
              dot: false,
              submenuItems: [],
            },
            {
              label: "Manager Self-Service",
              link: routes.adminManagerSelfService,
              icon: "ti ti-users-group",
              submenu: false,
              showSubRoute: false,
              dot: false,
              submenuItems: [],
            },
            // {
            //   label: "Id card",
            //   link: routes.idCard.list,
            //   icon: "ti ti-id",
            //   submenu: false,
            //   showSubRoute: false,
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "e-office",
            //   link: routes.eOffice,
            //   icon: "ti ti-file-text",
            //   submenu: false,
            //   showSubRoute: false,
            //   dot: false,
            //   submenuItems: [],
            // },
            {
              label: "NOCs",
              link: routes.noc.main,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-file-certificate",
              base: "noc",
              materialicons: "noc",
              dot: false,
              submenuItems: [
                {
                  label: "Outside Job",
                  link: routes.noc.outsideJob,
                  icon: "ti ti-briefcase",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Passport / Visa",
                  link: routes.noc.passport,
                  icon: "ti ti-id",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Higher Education",
                  link: routes.noc.higherEducation,
                  icon: "ti ti-school",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Ex-India (Foreign Visit)",
                  link: routes.noc.foreignVisit,
                  icon: "ti ti-plane",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Reimbursement/Addition of Online Course",
                  link: routes.noc.onlineCourse,
                  icon: "ti ti-device-laptop",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
          ],
        },

        // {
        //   label: "Leave",
        //   link: "",
        //   submenu: true,
        //   showSubRoute: false,
        //   icon: "ti ti-user-off",
        //   base: "dashboard",
        //   materialicons: "leave",
        //   dot: false,
        //   submenuItems: [
        //     {
        //       label: "Leave Request",
        //       link: "",
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Leave Status",
        //       link: "",
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //   ],
        // },
        {
          label: "Attendance",
          link: "",
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-clipboard-check",
          base: "dashboard",
          materialicons: "attendance",
          dot: false,
          submenuItems: [
            {
              label: "Attendance Regularize",
              link: routes.attendance.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Face Data Regularize",
              link: routes.employees.verifications,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Daily Attendance",
              link: routes.employeeDailyAttendence,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            // {
            //   label: "Attendance Request",
            //   link: "",
            //   icon: "ti ti-settings",
            //   submenu: false,
            //   showSubRoute: false,
            // },
            {
              label: "Monthly Attendance",
              link: routes.attendanceSummary,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
          ],
        },
        {
          label: "Administration",
          link: "",
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-user-cog",
          base: "dashboard",
          materialicons: "administration",
          dot: false,
          submenuItems: [
            {
              label: "Roles & Permissions",
              link: routes.rolesPermissions,
              submenu: false,
              showSubRoute: false,
              icon: "user-star",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Admin Users",
              link: routes.adminUsers,
              icon: "user-star",
              submenu: false,
              showSubRoute: false,
            },
            // {
            //   label: "Users & Roles",
            //   link: "",
            //   icon: "ti ti-settings",
            //   submenu: false,
            //   showSubRoute: false,
            // },
            {
              label: "Master Work schedule",
              link: routes.adminWorkSchedule,
              submenu: false,
              showSubRoute: false,
              icon: "user-star",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Designation & Departments",
              link: routes.masters.wingDesignationDepartment,
              submenu: false,
              showSubRoute: false,
              icon: "user-star",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            // {
            //   label: "Departments",
            //   link: routes.findAllDepartment,
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "user-star",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Designations",
            //   link: routes.findAllDesignation,
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "user-star",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [],
            // },
            {
              label: "Master Dnar List",
              link: routes.masters.dnarList,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Course Department",
              link: routes.masters.courseDepartmentList,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },

            {
              label: "Master Leave Type",
              link: routes.settings.leave.leaveType,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Nature of Duty",
              link: routes.masters.natureOfDuty,
              icon: "ti ti-natureOfDuty",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Noc Travel",
              link: routes.masters.listNocTravel,
              icon: "ti ti-noc-travel",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Stay",
              link: routes.masters.listStays,
              icon: "ti ti-stay",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Status",
              link: routes.masters.listStatuses,
              icon: "ti ti-Status",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Nature",
              link: routes.masters.listNatures,
              icon: "nature list",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Caste",
              link: routes.masters.listCaste,
              icon: "ti ti-user",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Course Categories",
              link: routes.masters.listCourseCategories,
              icon: "ti ti-category",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Course Types",
              link: routes.masters.listCourseTypes,
              icon: "ti ti-book",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Doc Upload Types",
              link: routes.masters.listDocUploadTypes,
              icon: "ti ti-upload",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Modes of Course",
              link: routes.masters.listModesOfCourse,
              icon: "ti ti-graduation-cap",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Master Holiday calendar",
              link: routes.holidaysCalendar,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Data Synchronization",
              link: routes.dataSync,
              icon: "ti ti-refresh",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Reimbursement Sync",
              link: routes.reimbursementSync,
              icon: "ti ti-receipt-tax",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Announcements",
              link: routes.announcements.list,
              icon: "ti ti-speakerphone",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "E-Attestation Master",
              link: routes.eAttestation.master,
              icon: "ti ti-database",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "E-Attestation Approver",
              link: routes.eAttestation.approver,
              icon: "ti ti-user-check",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "chatbot",
              link: routes.chatbot.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-dashboard",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
          ],
        },
        {
          label: "Settings",
          link: "",
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-settings",
          base: "dashboard",
          materialicons: "settings",
          dot: false,
          submenuItems: [
            {
              label: "App Settings",
              link: routes.settings.app,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-settings",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Config Vars",
                  link: routes.settings.configVars,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "General",
                  link: routes.settings.general,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "E-Separation HR Wing Mapping",
                  link: routes.settings.esepHrWing,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "E-Separation HR Level Roster",
                  link: routes.settings.esepHrLevelConfig,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Mobile App",
                  link: routes.settings.app,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Modules",
                  link: routes.settings.modules,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Email setup",
                  link: routes.settings.email,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "SMS setup",
                  link: routes.settings.sms,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Notification",
                  link: routes.settings.notification,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Storage Configuration",
                  link: routes.settings.storage,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Language",
                  link: routes.language.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-building",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
            // {
            //   label: "Leave Settings",
            //   link: routes.settings.app,
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-settings",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "Leave Type",
            //       link: "",
            //       icon: "ti ti-settings",
            //       submenu: false,
            //       showSubRoute: false,
            //     },
            //   ],
            // },
          ],
        },

        {
          label: "Content Management",
          link: "",
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-files",
          base: "dashboard",
          materialicons: "ContentManagement",
          dot: false,
          submenuItems: [
            {
              label: "SMS Templates",
              link: routes.templates.smsTemplates,
              icon: "ti ti-message",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Email Templates",
              link: routes.templates.emailTemplates,
              icon: "ti ti-mail",
              submenu: false,
              showSubRoute: false,
            },
          ],
        },

        {
          label: "Logs",
          link: "",
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-alert-circle",
          base: "dashboard",
          materialicons: "Logs",
          dot: false,
          submenuItems: [
            {
              label: "Audit Logs",
              link: routes.auditLogs,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Admin Activity Logs",
              link: routes.adminActivityLogs,
              icon: "ti ti-user-check",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Noc Sap Logs",
              link: routes.nocSapLogs,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Login Logs",
              link: routes.logs.loginLogs,
              icon: "ti ti-login",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Error List",
              link: routes.settings.errorList,
              icon: "ti ti-error",
              submenu: false,
              showSubRoute: false,
            },
            {
              label: "Otp Logs",
              link: routes.otpLogs,
              submenu: false,
              showSubRoute: false,
              icon: "user-star",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Sap Logs",
              link: routes.hrmsApiLogs,
              icon: "ti ti-settings",
              submenu: false,
              showSubRoute: false,
            },
          ],
        },

        // {
        //   label: "Settings",
        //   link: "",
        //   submenu: true,
        //   showSubRoute: false,
        //   icon: "ti ti-settings",
        //   base: "dashboard",
        //   materialicons: "settings",
        //   dot: false,
        //   submenuItems: [
        //     {
        //       label: "App Settings",
        //       link: routes.settings.app,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "SMS Settings",
        //       link: routes.settings.sms,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Email Settings",
        //       link: routes.settings.email,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Notification Settings",
        //       link: routes.settings.notification,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },

        //     {
        //       label: "Global Settings",
        //       link: routes.settings.global,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Language",
        //       link: routes.settings.language,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Pusher Settings",
        //       link: routes.settings.pusher,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "ReCaptcha Settings",
        //       link: routes.settings.recaptcha,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Storage Settings",
        //       link: routes.settings.storage,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Cache Settings",
        //       link: routes.settings.cache,
        //       icon: "ti ti-settings",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //     {
        //       label: "Error List",
        //       link: routes.settings.errorList,
        //       icon: "ti ti-error",
        //       submenu: false,
        //       showSubRoute: false,
        //     },
        //   ],
        // },
      ],
    },
  ],
  EMPLOYEE: [
    {
      tittle: "Self Services",
      icon: "airplay",
      showAsTab: true,
      separateRoute: false,
      submenuItems: [
        {
          label: "Dashboard",
          link: routes.employeeDashboard,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-layout-dashboard",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "My Profile",
          link: routes.myProfile,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-user-circle",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },

        {
          label: "Assigned Location",
          link: routes.location.list,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-map-pin",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "Attendance",
          link: routes.services.list,
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-calendar-time",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [
            {
              label: "Face Data Regularize",
              link: routes.employeeFaceData,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Daily attendance",
              link: routes.employeeDailyAttendence,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Attendance Regularize",
              link: routes.employeeAttendenceRegularize,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Attendance summary",
              link: routes.teamShiftOverview,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            // {
            //   label: "Employee Appraisal & Performance Management",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# APAR Download",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# APAR Team Status Display",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Employee Data & Identity Management",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Application for New I-Card",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Inclusion/Deletion of Dependent...",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Medical & Leave Encashment Applications",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Prior Approval for IVF, Para 6.2/6.3",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Leave Encashment (for EL Beyond 60 Leave)",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Tax, Reimbursement & Loan Management",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Display Tax Card",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Loan Module",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Loan Surety Status Check",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Employee Notifications & Miscellaneous HR Functions",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Police Verification Status",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Notification",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Transfer Applications",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Transfer Posting/ Process",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "NOCs (No Objection Certificates)",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# NOC for Ex-India (Foreign Visit)",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# NOC for Higher Studies/ Online Course...",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Miscellaneous HR Functions",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Salary Statement",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Staff Welfare Fund Grants",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "VPF Contribution Module",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# VPF Contribution Amount...",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Addition HR Support Service",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Upload Employee Photo",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Employee Search (Who is Who)",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Health and Welfare Applications",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Authority Letter for Annual Health Checkup",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Reimbursement Claims/ Advances",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
            // {
            //   label: "Other HR Modules",
            //   submenu: true,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [
            //     {
            //       label: "# Annual Property Return Submission",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Appraisal Document",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Booking of Community Hall/ Common Room/Park",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Changed Password",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Contribution On Appeal",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Due Drawn",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# E-Attestation Process",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Inclusion of Parents as Dependents",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Intimation of Movable Property",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# It Declaration",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Managar Self-Service Module",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Multiple Salary Statement",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Reimbursement/ Addition of Online",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# SAP Authorization Form",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# SV4 Card ( Issue/Reissue)",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Tax Simplifier Statement",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# Salary Statement (Hindi)",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //     {
            //       label: "# E-Requisition (IT)",
            //       submenu: true,
            //       showSubRoute: false,
            //       icon: "ti ti-building",
            //       base: "dashboard",
            //       materialicons: "start",
            //       dot: false,
            //       submenuItems: [],
            //     },
            //   ],
            // },
          ],
        },

        // {
        //   label: "Leave",
        //   link: routes.leave.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        // },

        {
          label: "DMRC Calendar",
          link: routes.dmrcCalendar,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-calendar",
          base: "dmrc-calendar",
          materialicons: "calendar",
          dot: false,
          submenuItems: [],
        },
        // {
        //   label: "Events",
        //   // link: routes.leave.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        // },

        {
          label: "Setting",
          link: routes.employeeSetting,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-settings",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "Circular",
          link: routes.circulars.main,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-file-text",
          base: "circulars",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        // {
        //   label: "Help",
        //   // link: routes.leave.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        // },
        {
          label: "Services",
          link: routes.services.list,
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-briefcase",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [
            {
              label: "NOCs (No Objection Certification)",
              slug: "nocs_no_objection_certificates",
              link: routes.noc.main,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-briefcase",
              base: "noc",
              materialicons: "noc",
              dot: false,
              submenuItems: [
                // {
                //   label: "Vpf",
                //   link: routes.vpf.list,
                //   icon: "ti ti-briefcase",
                //   submenu: false,
                //   showSubRoute: false,
                //   dot: false,
                //   submenuItems: [],
                // },
                {
                  label: "Outside Job",
                  slug: "noc_for_outside_job",
                  link: routes.noc.outsideJob,
                  icon: "ti ti-briefcase",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Passport / Visa",
                  slug: "noc_for_passport_visa",
                  link: routes.noc.passport,
                  icon: "ti ti-id",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Higher Education",
                  slug: "noc_for_higher_education",
                  link: routes.noc.higherEducation,
                  icon: "ti ti-school",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Ex-India (Foreign Visit)",
                  slug: "noc_for_ex_india_foreign_visit",
                  link: routes.noc.foreignVisit,
                  icon: "ti ti-plane",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Reimbursement/Addition of Online Course",
                  slug: "noc_reimbursement_addition_of_online_course",
                  link: routes.noc.onlineCourse,
                  icon: "ti ti-device-laptop",
                  submenu: false,
                  showSubRoute: false,
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
            {
              label: "Employee Data & Identity Management",
              slug: "employee_data_identity_management",
              link: "#",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-id",
              base: "dashboard",
              materialicons: "id",
              dot: false,
              submenuItems: [
                {
                  label: "Application for new I-Card",
                  slug: "application_for_new_icard",
                  link: routes.idCard.list,
                  icon: "ti ti-file-text",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Inclusion of dependent parents including widow mother",
                  slug: "inclusion_of_dependent_parents_including_widow_mother",
                  link: routes.idCard.inclusionOfDependent,
                  icon: "ti ti-file-text",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Deletion of dependent parents including widow mother",
                  slug: "deletion_of_dependent_parents_including_widow_mother",
                  link: routes.idCard.deletionOfDependent,
                  icon: "ti ti-file-text",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "List of Inclusion / Deletion of family members (Spouse and Children)",
                  slug: "list_of_inclusion_deletion_of_family_members_spouse_children",
                  link: routes.idCard.familyMemberInclusion,
                  icon: "ti ti-file-text",
                  submenu: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              label: "Leave Management",
              slug: "all_leave_tab",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Leave Request",
                  link: routes.LeaveManagement.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-file",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Calendar",
                  link: routes.LeaveManagement.calendar,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-calendar",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Team Calendar",
                  link: routes.LeaveManagement.teamCalendar,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-users",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Time Accounts",
                  link: routes.LeaveManagement.timeAccounts,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-clock",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                }
              ],
            },
            {
              label: "Medical & Leave Encashment",
              slug: "employee_medical_leave_encashment",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-heartbeat",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Leave Encashment for EL beyond 60 leave",
                  slug: "leave_encashment_for_el_beyond_60_leave",
                  link: routes.leaveEncashment.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-cash",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Prior Approval for IVF, Para 6.2/6.3",
                  slug: "prior_approval_for_ivf_para_6_2_6_3_treatment",
                  link: routes.medicalAttendance.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-stethoscope",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
            {
              label: "VPF Contribution Module",
              slug: "employee_vpf_contribution_module",
              link: routes.vpfModule.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-coin",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Employee Public Holiday / Birthday",
              slug: "employee_public_holidays_birthday",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-calendar-event",
              base: "dashboard",
              materialicons: "event",
              dot: false,
              submenuItems: [
                {
                  label: "Birthday and Anniversaries",
                  slug: "birthday_and_anniversaries",
                  link: routes.birthdayAnniversaries,
                  icon: "ti ti-gift",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Public holiday",
                  slug: "public_holiday",
                  link: routes.publicHolidays,
                  icon: "ti ti-calendar",
                  submenu: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              label: "Reimbursement Claims/Advances",
              slug: "reimbursement_claims_advances_all",
              // link: routes.reimbursementClaims,
              link: routes.Reimbursement.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Staff Quarter Application",
              slug: "staff_quarter_applications",
              link: routes.staffQuarter.list,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-home-plus",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                // {
                //   label: "Staff Quarter Overview",
                //   link: routes.staffQuarter.overview,
                //   icon: "ti ti-settings",
                //   submenu: false,
                //   showSubRoute: false,
                // },
                {
                  label: "Staff Quarter Overview",
                  link: routes.staffQuarter.list,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Occupation / Withdrawal",
                  link: routes.staffQuarter.occupation,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Vacation Request",
                  link: routes.staffQuarter.vacationIntimation,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Mutual Exchange",
                  link: routes.staffQuarter.mutualExchange,
                  icon: "ti ti-arrows-exchange",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Unwillingness",
                  link: routes.staffQuarter.unwillingness,
                  icon: "ti ti-ban",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "My Priority",
                  link: routes.staffQuarter.priorityList,
                  icon: "ti ti-list-numbered",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "My Allotments",
                  link: routes.staffQuarter.myAllotments,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },

              ],
            },
            {
              label: "Post-Promotional",
              slug: "dmrc_promotion_of_employees_process",
              link: routes.PostPromotion.list,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-arrow-up-right-circle",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Promotion Lists (A-E)",
                  link: routes.PostPromotion.list,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "DPC Review",
                  link: routes.PostPromotion.DpcReview,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Competent Authority Review",
                  link: routes.PostPromotion.DpcApprovalList,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Promotion Office Orders",
                  link: routes.PostPromotion.OfficeOrders,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                // {
                //   label: "SAP Sync Audit Logs",
                //   link: routes.PostPromotion.sapSyncLog,
                //   icon: "ti ti-settings",
                //   submenu: false,
                //   showSubRoute: false,
                // },
              ],
            },
            {
              label: "Probation",
              slug: "dmrc_promotion_of_employees_process",
              link: routes.probation.dashboard,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-user-check",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Probation Dashboard",
                  link: routes.probation.dashboard,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                // {
                //   label: "Probation Cycles Dashboard",
                //   link: routes.probation.cyclesDashboard,
                //   icon: "ti ti-settings",
                //   submenu: false,
                //   showSubRoute: false,
                // },
                {
                  label: "Screening Committee Review",
                  link: routes.probation.committeeReview,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Competent Authority Approval",
                  link: routes.probation.approvalList,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Probation Office Orders",
                  link: routes.probation.officeOrders,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              label: "D&AR-Cases",
              slug: "dmrc_employee_discipline_and_appeal_rules",
              link: routes.darCase.overview,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-gavel",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Overview",
                  link: routes.darCase.overview,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "D&AR Contemplated",
                  link: routes.darCase.contemplated,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "D&AR Pending",
                  link: routes.darCase.pending,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "D&AR Closed",
                  link: routes.darCase.closed,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Appeal Against Penalty",
                  link: routes.darCase.appealAgainstPenalty,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: " Suspension / Deemed Suspension",
                  link: routes.darCase.sdSuspension,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Role Management",
                  link: routes.darCase.roleManagement,
                  icon: "ti ti-settings",
                  submenu: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              label: "E-Sepration",
              slug: "dmrc_employee_e_separation_module",
              link: routes.Esepration.hub,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-user-off",
              base: "dashboard",
              materialicons: "start",
              dot: false,
            },

            {
              label: "Employee Miscellaneous HR Functions",
              slug: "hr_miscellaneous_functions",
              // link: routes.miscHR,
              link: routes.leave.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Salary Statement",
              slug: "salary_statement",
              link: routes.salaryStatement,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-receipt",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Staff Welfare Fund Grants",
              slug: "staff_welfare_fund_grants",
              link: routes.staffWelfareFund.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-heart-handshake",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Transfer & Posting",
              slug: "employee_transfer_posting_module",
              link: routes.selfTransfer.list,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-arrows-transfer-down",
              base: "self-transfer",
              materialicons: "start",
              dot: false,
              submenuItems: [

                {
                  label: "Internal Vacancy (DMRC/Outstation/Vigilance/Misc)",
                  slug: "internal_vacancy_dmrc_outstation_vigilance_misc",
                  link: routes.transferPosting.internalVacancy,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-building-broadcast",
                  base: "transfer-applications",
                  materialicons: "start",
                  dot: false,
                  disabled: true,
                  submenuItems: [],
                },
                {
                  label: "Self Transfer",
                  slug: "self_transfer",
                  link: routes.selfTransfer.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-arrows-exchange",
                  base: "self-transfer",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Mutual Transfer",
                  slug: "mutual_transfer",
                  link: routes.transferPosting.mutualTransfer,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-arrows-right-left",
                  base: "transfer-applications",
                  materialicons: "start",
                  dot: false,
                  disabled: true,
                  submenuItems: [],
                },
                {
                  label: "Transfer Cancellation",
                  slug: "transfer_cancellation",
                  link: routes.transferPosting.cancellation,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-x",
                  base: "transfer-applications",
                  materialicons: "start",
                  dot: false,
                  disabled: true,
                  submenuItems: [],
                },
                {
                  label: "Request for Posting",
                  slug: "request_for_posting",
                  link: routes.transferPosting.requestPosting,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-user-pin",
                  base: "transfer-applications",
                  materialicons: "start",
                  dot: false,
                  disabled: true,
                  submenuItems: [],
                },
                {
                  label: "Download Office Order of Transfer",
                  slug: "download_office_order_of_transfer",
                  link: routes.transferPosting.officeOrders,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-file-certificate",
                  base: "transfer-applications",
                  materialicons: "start",
                  dot: false,
                  disabled: true,
                  submenuItems: [],
                },
              ],
            },
            {
              label: "Medical & Leave Encashment Applications",
              slug: "employee_medical_leave_encashment",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-heartbeat",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Leave Encashment for EL beyond 60 leave",
                  slug: "leave_encashment_for_el_beyond_60_leave",
                  link: routes.leaveEncashment.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-cash",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
            {
              label: "Employee Appraisal & Performance Mgmt.",
              slug: "employee_apar",
              link: routes.apar.dashboard,
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-file-certificate",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "APAR Dashboard",
                  link: routes.apar.dashboard,
                  icon: "ti ti-layout-dashboard",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "APAR Download",
                  slug: "apar_download",
                  link: routes.apar.download,
                  icon: "ti ti-file-download",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Appraisal Documents",
                  slug: "appraisal_document",
                  link: routes.apar.documents,
                  icon: "ti ti-file-description",
                  submenu: false,
                  showSubRoute: false,
                },
                {
                  label: "Team Status Display",
                  slug: "apar_team_status_display",
                  link: routes.apar.teamStatus,
                  icon: "ti ti-users-group",
                  submenu: false,
                  showSubRoute: false,
                },
              ],
            },
            {
              label: "Employee Tax & Loan Management",
              slug: "employee_tax_and_loan_management",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-receipt-tax",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Display Tax Card",
                  slug: "display_tax_card",
                  link: routes.displayTaxCard,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-file-text",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Tax Simplifier Statement",
                  slug: "tax_simplifier_statement",
                  link: routes.taxSimplifier,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-receipt-tax",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Loan Surety Status Check",
                  slug: "loan_surety_status_check",
                  link: routes.loanSurety,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-shield-check",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
            {
              label: "Employee Health & Welfare Application",
              slug: "employee_health_welfare_applications",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-heartbeat",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Authority Letter for Annual Comprehensive Health Checkup",
                  slug: "authority_letter_for_annual_comprehensive_health_checkup",
                  link: routes.authorityLetterHealthCheckup.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-heart",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Staff Welfare Fund Grants",
                  slug: "staff_welfare_fund_grants",
                  link: routes.staffWelfareFund.list,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-heart-handshake",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
            {
              label: "Employee Financial & Retirement Benefits",
              slug: "employee_financial_retirement_benefits",
              link: "",
              submenu: true,
              showSubRoute: false,
              icon: "ti ti-coin",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [
                {
                  label: "Annual NPS/Superannuation Detail",
                  slug: "annual_nps_superannuation_application",
                  link: routes.annualNps,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-trending-up",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
                {
                  label: "Annual PF Details",
                  slug: "annual_pf_details",
                  link: routes.annualPf,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-wallet",
                  base: "dashboard",
                  materialicons: "start",
                  dot: false,
                  submenuItems: [],
                },
              ],
            },
          ],
        },

        {
          label: "Other Service",
          link: routes.leave.list,
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-apps",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [
            {
              label: "Annual Property Return",
              slug: "annual_property_return_submission",
              link: routes.annualPropertyReturn,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-file-text",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Appraisal Document",
              slug: "appraisal_document",
              link: routes.apar.documents,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-file-description",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Booking of Community Hall/Common Room/Park",
              slug: "booking_of_community_hall_common_room_park",
              link: routes.communityHall.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Contribution On Appeal",
              slug: "appeal_for_contribution",
              link: routes.appealContribution.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-heart-handshake",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Due Drawn",
              slug: "due_drawn",
              link: routes.dueDrawn,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "E-Attestation Process",
              slug: "e_attestation_process",
              link: routes.eAttestation.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-certificate",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Inclusion of Parents as Dependents",
              slug: "inclusion_of_dependent_parents_including_widow_mother",
              link: routes.leave.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Intimation of Movable Property",
              slug: "intimation_of_movable_property",
              link: routes.leave.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "IT Declaration",
              slug: "it_declaration",
              link: routes.itDeclaration.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-file-check",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Manager Self-Service Module",
              slug: "manager_self_service_module",
              link: routes.managerSelfService,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-users-group",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Multiple Salary Statement",
              slug: "multiple_salary_statement",
              link: routes.multipleSalaryStatement,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-files",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Police Verification",
              slug: "police_verification",
              link: routes.policeVerification,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-shield-check",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            // {
            //   label: "Reimbursement/Addition of Online Course",
            //   link: routes.Reimbursement.list,
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-building",
            //   base: "dashboard",
            //   materialicons: "start",
            //   dot: false,
            //   submenuItems: [],
            // },
            {
              label: "SAP Authorization Form",
              slug: "sap_authorization_form",
              link: routes.sapAuthorization.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-lock-access",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "SV4 Card (Issue/Reissue)",
              slug: "sv4_card_issue_reissue",
              link: routes.sv4Card.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Tax Simplifier Statement",
              slug: "tax_simplifier_statement",
              link: routes.taxSimplifier,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-receipt-tax",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Salary Statement",
              slug: "salary_statement",
              link: routes.salaryStatement,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-file-text",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Change Password",
              slug: "change_password",
              link: routes.changePassword,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-lock",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "E-Requisition (IT)",
              slug: "e_requisition_it",
              link: routes.eRequisitionIT.list,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-building",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
            {
              label: "Who is Who",
              slug: "who_is_who_employee_directory_search",
              link: routes.whoIsWho,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-users",
              base: "dashboard",
              materialicons: "start",
              dot: false,
              submenuItems: [],
            },
          ],
        },
        {
          label: "Notifications",
          link: routes.notification,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-bell",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
      ],
    },
    {
      tittle: "Team services",
      icon: "airplay",
      showAsTab: true,
      separateRoute: false,
      submenuItems: [
        {
          label: "Attendance Regularize",
          link: routes.attendance.list,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-edit-circle",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "My Team",
          link: routes.reportingEmployees,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-users",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "Employees Attendance",
          link: routes.reportingEmployeesDailyAttendence,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-user-check",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "Face Data Regularize",
          link: routes.employees.verifications,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-face-id",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        {
          label: "To-Do Work List",
          link: routes.toDoList,
          submenu: true,
          showSubRoute: false,
          icon: "ti ti-list-check",
          base: "worklist",
          materialicons: "task",
          dot: false,
          submenuItems: [
            {
              label: "Universal Worklist",
              link: routes.todoWorklist.tasks,
              submenu: false,
              showSubRoute: false,
              icon: "ti ti-list-check",
              base: "universal-worklist",
              materialicons: "universal",
              dot: false,
              submenuItems: [],
            },
            // {
            //   label: "CLMS: Advance claims application",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-clipboard-text",
            //   base: "clms",
            //   materialicons: "clms",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Staff Welfare Fund Approval",
            //   link: routes.todoWorklist.tasks,
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-heart-handshake",
            //   base: "welfare",
            //   materialicons: "welfare",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "IT Declaration Approval",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-file-text",
            //   base: "it-declaration",
            //   materialicons: "it",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Loan Approval",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-credit-card",
            //   base: "loan",
            //   materialicons: "loan",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "E Attestation Approval",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-certificate",
            //   base: "attestation",
            //   materialicons: "attestation",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Posting Of Transfer Section",
            //   link: routes.worklist.transferPosting,
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-user-bolt",
            //   base: "transfer",
            //   materialicons: "transfer",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Relieving of Transfer Section",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-user-off",
            //   base: "relieving",
            //   materialicons: "relieving",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Approve Request",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-check",
            //   base: "approve",
            //   materialicons: "approve",
            //   dot: false,
            //   submenuItems: [],
            // },
            // {
            //   label: "Upload photo for database",
            //   link: "#",
            //   submenu: false,
            //   showSubRoute: false,
            //   icon: "ti ti-photo",
            //   base: "photo",
            //   materialicons: "photo",
            //   dot: false,
            //   submenuItems: [],
            // },
            {
              label: "Staff Quarter Management",
              link: routes.staffQuarter.management.overview,
              icon: "ti ti-users-cog",
              submenu: true,
              showSubRoute: false,
              submenuItems: [
                // {
                //   label: "Overview",
                //   link: routes.staffQuarter.management.overview,
                //   submenu: false,
                //   showSubRoute: false,
                //   icon: "ti ti-dashboard",
                // },
                {
                  label: "Inbox",
                  link: routes.staffQuarter.management.requests,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-file-import",
                },
                {
                  label: "Allotment",
                  link: routes.staffQuarter.management.allotments,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-building-community",
                },
                {
                  label: "Mutual Exchange",
                  link: routes.staffQuarter.management.mutualExchange,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-arrows-exchange",
                },
                {
                  label: "Priority List",
                  link: routes.staffQuarter.management.priorityList,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-list-ol",
                },
                {
                  label: "Reports",
                  link: routes.staffQuarter.management.reports,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-chart-pie",
                },
                {
                  label: "Willingness",
                  link: routes.staffQuarter.management.willingnessInvited,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-mail-forward",
                },
                {
                  label: "Inventory",
                  link: routes.staffQuarter.inventory.dashboard,
                  submenu: true,
                  showSubRoute: false,
                  icon: "ti ti-database",
                  submenuItems: [
                    {
                      label: "Dashboard",
                      link: routes.staffQuarter.inventory.dashboard,
                      submenu: false,
                      showSubRoute: false,
                      icon: "ti ti-dashboard",
                    },
                    {
                      label: "Flat Master",
                      link: routes.staffQuarter.inventory.master,
                      submenu: false,
                      showSubRoute: false,
                      icon: "ti ti-table",
                    },
                    // {
                    //   label: "Vacation Init",
                    //   link: routes.staffQuarter.inventory.vacation,
                    //   submenu: false,
                    //   showSubRoute: false,
                    //   icon: "ti ti-door-exit",
                    // },
                    {
                      label: "History",
                      link: routes.staffQuarter.inventory.history,
                      submenu: false,
                      showSubRoute: false,
                      icon: "ti ti-history",
                    },
                  ],
                },
                {
                  label: "Approval Settings",
                  link: routes.settings.staffQuarterApproval,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-settings-cog",
                },
                {
                  label: "Change Current Approver",
                  link: routes.staffQuarterAdmin.changeApprover,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-user-shield",
                },
                {
                  label: "Letter Customization",
                  link: routes.staffQuarterAdmin.letterTemplates,
                  submenu: false,
                  showSubRoute: false,
                  icon: "ti ti-file-certificate",
                },
              ],
            },
          ],
        },
      ],
    },
    {
      tittle: "Management Services ",
      icon: "airplay",
      showAsTab: true,
      separateRoute: false,
      submenuItems: [
        {
          label: "Announcements",
          link: routes.announcements.list,
          icon: "ti ti-speakerphone",
          submenu: false,
          showSubRoute: false,
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
          permissionCode: routes.announcements.list.slice(1),
        },
        {
          label: "Office Location Master",
          link: routes.officeLocation.list,
          submenu: false,
          showSubRoute: false,
          icon: "ti ti-map-pin",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
          permissionCode: routes.officeLocation.list.slice(1),
        },
        {
          label: "Work Shift Master",
          link: routes.workShift,
          submenu: false,
          showSubRoute: false,
          icon: "user-star",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
          permissionCode: routes.workShift.slice(1),
        },

        {
          label: "Office Location",
          link: routes.employees.officeLocation,
          showSubRoute: false,
          icon: "ti ti-building",
          base: "dashboard",
          materialicons: "start",
          dot: false,
          submenuItems: [],
        },
        // {
        //   label: "Work Shift",
        //   link: routes.reportingEmployeeShift,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],

        // },
        // {
        //   label: "Work Schedule",
        //   link: routes.services.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        // },
        // {
        //   label: "App Settings",
        //   // link: routes.leave.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        // },
        // {
        //   label: "Website settings",
        //   // link: routes.leave.list,
        //   submenu: false,
        //   showSubRoute: false,
        //   icon: "ti ti-building",
        //   base: "dashboard",
        //   materialicons: "start",
        //   dot: false,
        //   submenuItems: [],
        // },
      ],
    },

    // {
    //   tittle: "Top Corner Menu",
    //   icon: "airplay",
    //   showAsTab: true,
    //   separateRoute: false,
    //   submenuItems: [
    //     {
    //       label: "My Profile",
    //       link: routes.leave.list,
    //       submenu: false,
    //       showSubRoute: false,
    //       icon: "ti ti-building",
    //       base: "dashboard",
    //       materialicons: "start",
    //       dot: false,
    //       submenuItems: [],
    //     },
    //     {
    //       label: "Change Password",
    //       link: routes.changePassword,
    //       submenu: false,
    //       showSubRoute: false,
    //       icon: "ti ti-building",
    //       base: "dashboard",
    //       materialicons: "start",
    //       dot: false,
    //       submenuItems: [],
    //     },
    //     {
    //       label: "Logout",
    //       link: routes.services.list,
    //       submenu: false,
    //       showSubRoute: false,
    //       icon: "ti ti-building",
    //       base: "dashboard",
    //       materialicons: "start",
    //       dot: false,
    //       submenuItems: [],
    //     },
    //   ],
    // },
  ],
};
